module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/georgia-tech-6dcc93325a476e76982cbac92b2cf2d9.svg";